define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var HolderValidationRequest = (function () {
        function HolderValidationRequest(pksErp, importedHolderId, holderValidationInfo) {
            this.pksErp = pksErp;
            this.importedHolderId = importedHolderId;
            this.holderValidationInfo = holderValidationInfo;
        }
        return HolderValidationRequest;
    }());
    exports.default = HolderValidationRequest;
});
